import React from 'react';
import CustomerLinkCell from 'components/ReactTable/CellRenderers/CustomerLinkCell';
import AccountLinkCell from 'components/ReactTable/CellRenderers/AccountLinkCell';
import SelectFilter from 'components/ReactTable/Filters/SelectFilter';
import GetOptions from './GetOptions';

// note: for the sorting to work, the 'accessor' properties below must have the same name as the backend property to be sorted by
const legalEntityColumnDefs = permissions => [
  {
    Header: 'Legal Entity Name',
    accessor: 'legalEntityName',
    disableFilters: true,
    className: 'col-20p'
  },
  {
    Header: 'Legal Entity Code',
    accessor: 'legalEntityClientIdentifier',
    disableFilters: true,
    className: 'col-10p'
  },
  {
    Header: 'Is Legal Entity Active?',
    accessor: 'legalEntityIsActive',
    Filter: SelectFilter,
    filterType: 'bool',
    options: GetOptions('isActive'),
    className: 'col-10p'
  },
  {
    Header: 'Account',
    accessor: 'account',
    Cell: (cellInfo) => {
      const { row: { original } } = cellInfo;
      return (<AccountLinkCell dataKey="accountId" data={ original } permissions={ permissions } />);
    },
    className: 'col-20p'
  },
  {
    Header: 'Is Account Active?',
    accessor: 'accountIsActive',
    Filter: SelectFilter,
    filterType: 'bool',
    options: GetOptions('isActive'),
    className: 'col-10p'
  },
  {
    Header: 'Customer',
    accessor: 'customer',
    Cell: (cellInfo) => {
      const { row: { original } } = cellInfo;
      return (<CustomerLinkCell dataKey="customerDbId" data={ original } permissions={ permissions } />);
    },
    className: 'col-20p'
  },
  {
    Header: 'Is Customer Active?',
    accessor: 'customerIsActive',
    // eslint-disable-next-line
    Filter: ({ column }) => <SelectFilter column={ column } className={ 'clickover-bottom-left' } />,
    filterType: 'bool',
    options: GetOptions('isActive'),
    className: 'col-10p'
  },
  {
    Header: 'Item Id',
    accessor: 'itemId',
    isVisible: false
  }
];

export default legalEntityColumnDefs;
